
export const configData = [
 
  {id:1, name: "Reception", fields: ["Bride", "Reception"],  },
   {id:2, name: "Marriage", fields: ["Bride", "Reception"],  },
    { id:3,name: "Marriage", fields: ["Bride", "Reception"],  },
    {id:4, name: "Team Meeting", fields: ["Agenda", "Room"],  }, 
  {id:4, name: "Team Meeting", fields: ["Agenda", "Room"],  }, 

  
];





